import { Link, usePage } from "@inertiajs/react";
import { NavLink, ThemeIcon } from "@mantine/core";
import { IconPlus } from "@tabler/icons-react";
import { useState } from "react";
import { useAdmin } from "../../hooks/useProps";
import { useYearContext } from "../../hooks/useYearContext";
import {
  admins_path,
  apprentice_supervisors_path,
  apprentices_path,
  coaches_path,
  companies_path,
  documents_path,
  global_documents_path,
  groups_path,
  new_observation_path,
  report_configurations_path,
  reports_path,
  schools_path,
  signatures_path,
  year_contexts_path,
} from "../../routes";

export function Navbar() {
  const { component } = usePage();
  const isAdmin = useAdmin();
  const [open, setOpen] = useState(true);
  const { pathWithYearContext } = useYearContext();

  return (
    <nav>
      <NavLink
        component={Link}
        href={pathWithYearContext(apprentices_path)}
        label="Lernende"
        active={component === "users/apprentice/Apprentices"}
      />
      <NavLink
        component={Link}
        href={pathWithYearContext(new_observation_path)}
        rightSection={
          <ThemeIcon color="zli-blue" variant="subtle">
            <IconPlus />
          </ThemeIcon>
        }
        label="Beobachtungen"
        active={component === "observation/ObservationCreate"}
      />
      <NavLink
        component={Link}
        href={pathWithYearContext(documents_path)}
        label="Dokumente"
        active={component === "document/general/Documents"}
      />
      <NavLink component={Link} href={pathWithYearContext(reports_path)} label="Berichte" active={component === "report/Reports"} />
      {isAdmin && (
        <NavLink label="Administration" opened={open} onClick={() => setOpen(!open)}>
          <NavLink component={Link} href={pathWithYearContext(groups_path)} label="Gruppen" active={component === "group/Groups"} />
          <NavLink
            component={Link}
            href={pathWithYearContext(year_contexts_path)}
            label="Jahrgänge"
            active={component === "yearContext/YearContexts"}
          />
          <NavLink component={Link} href={pathWithYearContext(coaches_path)} label="Coaches" active={component === "users/coach/Coaches"} />
          <NavLink
            component={Link}
            href={pathWithYearContext(apprentice_supervisors_path)}
            label="Berufsbildner/in"
            active={component === "users/apprenticeSupervisor/ApprenticeSupervisors"}
          />
          <NavLink component={Link} href={pathWithYearContext(admins_path)} label="Admins" active={component === "users/admin/Admins"} />
          <NavLink
            component={Link}
            href={pathWithYearContext(companies_path)}
            label="Lehrbetriebe"
            active={component === "company/Companies"}
          />
          <NavLink component={Link} href={pathWithYearContext(schools_path)} label="Schulen" active={component === "school/Schools"} />
          <NavLink
            component={Link}
            href={pathWithYearContext(report_configurations_path)}
            label="Berichtvorlagen"
            active={component === "reportConfig/ReportConfigs"}
          />
          <NavLink
            component={Link}
            href={pathWithYearContext(global_documents_path)}
            label="Globale Dokumente"
            active={component === "document/global/GlobalDocuments"}
          />
          <NavLink
            component={Link}
            href={pathWithYearContext(signatures_path)}
            label="Unterschriften Pool"
            active={component === "signature/Signatures"}
          />
        </NavLink>
      )}
    </nav>
  );
}
